import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_api_key",
  ref: "createAPIKeyModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_create_api_key_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Create API Key", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_create_api_key_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_create_api_key_header",
  "data-kt-scroll-wrappers": "#kt_modal_create_api_key_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6" }
const _hoisted_11 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Please Note!"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createTextVNode(" Adding new API key may afftect to your "),
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Affiliate Income")
    ])
  ])
], -1)
const _hoisted_13 = { class: "mb-5 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "API Name", -1)
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Short Description", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "d-flex flex-column mb-10 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Category", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a Category...", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "CRM", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Project Alice", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Keenthemes", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, "General", -1)
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "mb-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Specify Your API Method"),
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip",
      title: "Your billing numbers will be calculated based on your API method"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " If you need more info, please check budget planning ")
], -1)
const _hoisted_32 = { class: "fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a API method...", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Open API", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "SQL Call", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "UI/UX", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Docs", -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "modal-footer flex-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_create_api_key_cancel",
  class: "btn btn-white me-3"
}, " Discard ", -1)
const _hoisted_42 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_create_api_key_submit",
  class: "btn btn-primary"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_Form, {
          id: "kt_modal_create_api_key_form",
          class: "form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                  ]),
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: "Your API Name",
                    name: "apiName",
                    modelValue: _ctx.apiData.apiName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiData.apiName) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "apiName" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    rows: "3",
                    name: "shortDescription",
                    placeholder: "Describe your API",
                    modelValue: _ctx.apiData.shortDescription,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apiData.shortDescription) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_ErrorMessage, { name: "shortDescription" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_Field, {
                    name: "category",
                    "data-control": "select2",
                    "data-hide-search": "true",
                    "data-placeholder": "Select a Category...",
                    class: "form-select form-select-solid",
                    as: "select",
                    modelValue: _ctx.apiData.category,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apiData.category) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_ErrorMessage, { name: "category" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Field, {
                      name: "apiMethod",
                      "data-control": "select2",
                      "data-hide-search": "true",
                      "data-placeholder": "Select a Category...",
                      class: "form-select form-select-solid",
                      as: "select",
                      modelValue: _ctx.apiData.apiMethod,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.apiData.apiMethod) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33,
                        _hoisted_34,
                        _hoisted_35,
                        _hoisted_36,
                        _hoisted_37
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "apiMethod" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("button", _hoisted_42, _hoisted_45, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}